import { createPatch } from 'diff';

function replaceHtmlTags(json: string) {
  return json
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');
}

function addPrettyPrintStyles(json: string) {
  return json.replace(
    /("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+-]?\d+)?)/g,
    function (match: string) {
      let cls = 'number';
      if (/^"/.test(match)) {
        if (/:$/.test(match)) {
          cls = 'key';
        } else {
          cls = 'string';
        }
      } else if (/true|false/.test(match)) {
        cls = 'boolean';
      } else if (/null/.test(match)) {
        cls = 'null';
      }
      return '<span class="' + cls + '">' + match + '</span>';
    },
  );
}

export function jsonPrettyPrint(json: any): string {
  return addPrettyPrintStyles(
    replaceHtmlTags(JSON.stringify(json, undefined, 2)),
  );
}

export function jsonPrettyPrintDiff(oldObj?: any, newObj?: any): string {
  const original = JSON.stringify(oldObj || {}, null, 2) + '\n';
  const updated = JSON.stringify(newObj || {}, null, 2) + '\n';
  const diff = createPatch('', original, updated, undefined, undefined, {
    ignoreWhitespace: true,
    context: Infinity,
  });

  return addPrettyPrintStyles(
    replaceHtmlTags(diff)
      .replace(/^\s*((\@\@.*\@\@)|(\=*)|(\-*)|(\+*)|(Index\:))\s*\n/gm, '') // remove diff hunk and headers lines
      .replace(/^\+(.*)$/gm, '<ins> $1</ins>') // diff added lines
      .replace(/^\-(.*)$/gm, '<del> $1</del>'), // diff removed lines
  );
}
